import { useEffect, useState } from "react";
import { errorText } from "./api.ts";

export interface Async<T> {
  data: T | null;
  error: string | null;
  loading: boolean;
}

/** Loads once per `key` change; ignores results of stale requests. */
export function useAsync<T>(load: () => Promise<T>, key: string): Async<T> {
  const [state, setState] = useState<Async<T>>({ data: null, error: null, loading: true });
  useEffect(() => {
    let cancelled = false;
    setState((s) => ({ ...s, loading: true, error: null }));
    load().then(
      (data) => !cancelled && setState({ data, error: null, loading: false }),
      (e: unknown) => !cancelled && setState({ data: null, error: errorText(e), loading: false }),
    );
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  return state;
}
